import type { ParagraphInfoNotice as ParagraphInfoNoticeData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphInfoNotice.module.css";

/**
 * Layout 62 - `PARAGRAPH_INFO_NOTICE_LAYOUT`: pojedyncza karta info.
 *
 * Struktura:
 *   - Karta mint bg + jasny border, 2-kol grid:
 *       - Ikona Nucleo Outline w mint kolku po lewej (opcjonalna)
 *       - Heading (text_1, uppercase teal) + treść (text, paragraf) po prawej
 *   - Bez H2 sekcji - cala tresc w karcie
 */
export function ParagraphInfoNotice({
  paragraph,
}: {
  paragraph: ParagraphInfoNoticeData;
  t: ParagraphTranslations;
}) {
  const { text_1: heading, text: body, icon } = paragraph;

  return (
    <section className={styles.section}>
      <div className={styles.card}>
        {icon ? (
          <div className={styles.iconBox} aria-hidden="true">
            <i className={`nc-icon-outline ${icon}`} />
          </div>
        ) : null}
        <div className={styles.body}>
          {heading ? <p className={styles.heading}>{heading}</p> : null}
          {body ? <p className={styles.text}>{body}</p> : null}
        </div>
      </div>
    </section>
  );
}
